<template>
    <div class="policy-wrapper p-4 md:p-6 surface-card border-round-xl shadow-1 text-left">
        <div class="mb-5">
            <p class="text-600 italic font-light mb-3">
                (Applicable to Tutors registered with ILearn’d Tutors Platform)
            </p>
            <p class="text-900 font-bold mb-2">Version: 1.0</p>
            <p class="text-900 font-bold mb-2">Jurisdiction: Democratic Socialist Republic of Sri Lanka</p>
            <p class="text-600 italic font-light">
                These Terms take effect from the date you access, browse, register an account on, or otherwise use the
                Platform or its services.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">1. INTRODUCTION</h2>
            <p class="text-body mb-2">
                1.1 These Terms and Conditions (“Terms”) constitute a binding legal agreement between <b>ILearn’d Tutors</b>
                (“the Platform”, “we”, “our”, or “us”) and any individual registered as a <b>Tutor</b> (“you”) for the purpose
                of providing educational services to students via the Platform.
            </p>
            <p class="text-body mb-2">
                1.2 By creating a tutor account, accepting bookings, or providing any educational services through the
                Platform, you agree to be bound by these Terms, the Platform’s Privacy Policy, and all other applicable
                policies published from time to time.
            </p>
            <p class="text-body">
                1.3 The Platform operates as an <b>intermediary service</b> facilitating connections between tutors and
                students and does <b>not employ tutors directly</b>. Tutors act as <b>independent contractors</b>, and nothing in
                these Terms shall be construed as creating an employer–employee, partnership, or agency relationship.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">2. ELIGIBILITY AND REGISTRATION</h2>
            <p class="text-body mb-2"><b>2.1</b> <b>Minimum Requirements:</b><br>Tutors must:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) Be at least 18 years of age;</li>
                <li class="mb-1">(b) Possess valid national identification (NIC or Passport); and</li>
                <li class="mb-1">(c) Provide accurate and verifiable personal and professional information.</li>
                <li>(d) Provide a CV</li>
            </ul>

            <p class="text-body mb-2"><b>2.2</b> <b>Mandatory Documentation:</b><br>Tutors must provide the following at registration:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) National ID or Passport;</li>
                <li class="mb-1">(b) Minimum G.C.E. A/L qualification (or equivalent);</li>
                <li class="mb-1">(c) Relevant teaching or professional qualifications from recognised institutions;</li>
                <li class="mb-1">(d) Recent photograph; and</li>
                <li>(e) Bank account details for payment processing.</li>
            </ul>

            <p class="text-body mb-2"><b>2.3</b> <b>Qualification Requirements:</b></p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) <b>Primary (Grades 1–5):</b> A/L qualification and teaching diploma preferred;</li>
                <li class="mb-1">(b) <b>Secondary (Grades 6–11):</b> Bachelor’s degree or equivalent;</li>
                <li class="mb-1">(c) <b>Advanced Level (Grades 12–13):</b> Subject-specific degree with teaching experience;
                </li>
                <li class="mb-1">(d) <b>University/Professional:</b> Postgraduate qualification or equivalent industry
                    expertise;</li>
                <li>(e) <b>International Curriculam :</b> Cambridge, Edexcel, or IB certifications as applicable.</li>
            </ul>

            <p class="text-body">
                <b>2.4</b> <b>Verification:</b> All documentation is subject to verification and periodic revalidation.
                ILearn’d Tutors reserves the right to request updates or suspend accounts pending verification.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">3. CONDUCT OF SESSIONS</h2>

            <p class="text-body font-bold mb-2">3.1 Individual Sessions</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) Tutors shall prepare detailed lesson plans 24 hours in advance.</li>
                <li class="mb-1">(b) Sessions must begin punctually and be conducted professionally.</li>
                <li>(c) Progress reports shall be maintained weekly for regular students.</li>
            </ul>

            <p class="text-body font-bold mb-2">3.2 Group Sessions</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) Students must be within 1–2 grade levels of one another.</li>
                <li class="mb-1">(b) Tutors shall ensure equal participation and maintain group progress reports.</li>
                <li>(c) Group pricing must be transparently communicated.</li>
            </ul>

            <p class="text-body font-bold mb-2">3.3 Online Sessions</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) Must be conducted exclusively through the Platform’s integrated video tools.</li>
                <li class="mb-1">(b) Tutors must maintain a quiet, professional background and stable internet
                    connection (minimum 10 Mbps).</li>
                <li class="mb-1">(c) No session recording is permitted without the explicit consent of all parties.</li>
                <li class="mb-1">(d) Personal contact details shall not be shared with students or parents.</li>
                <li class="mb-1">(e) Webcam must be turned on</li>
                <li class="mb-1">(f) Explicit Language is strictly prohibited</li>
                <li>(g) Must conduct class in a professional manner</li>
            </ul>

            <p class="text-body font-bold mb-2">3.4 AI-Assisted Session Participation</p>
            <p class="text-body mb-2">
                3.4.1 ILearn’d Tutors utilizes AI-assisted systems during online sessions to enhance learning quality,
                safety, and platform functionality.
            </p>
            <p class="text-body mb-2">
                3.4.2 Where AI-assisted tools are enabled on the Platform, The tutor participating in the session must
                invite or enable an AI assistant to join the session.
            </p>
            <p class="text-body mb-2">
                3.4.3 The AI assistant participates solely for the purpose of generating automated lesson summaries,
                organisational notes, learning insights, and transcripts intended to support learning and revision.
            </p>
            <p class="text-body mb-2">
                3.4.4 Access to full transcripts may depend on the subscription plan of the user accessing the content.
                In certain cases, transcripts generated for non-premium users may remain temporarily stored in a
                restricted state for a limited period (for example, up to ten (10) days) before being automatically
                deleted if the user does not upgrade their subscription.
            </p>
            <p class="text-body mb-2">
                3.4.5 The AI assistant functions only as a supportive educational tool and does not replace the tutor’s
                teaching responsibilities, professional judgment, or instructional role.
            </p>
            <p class="text-body mb-1">3.4.6 Tutors acknowledge that:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) the AI system is an integral part of the Platform;</li>
                <li class="mb-1">(b) participation in AI-assisted sessions is mandatory for access to Platform
                    features; and</li>
                <li class="mb-1">(c) refusal to allow AI system participation may result in restricted access to
                    classes, features, or account suspension.</li>
                <li>(d) 3rd Party AI tools added to sessions which are not provided by Ilearn’d Tutor may result in
                    restricted access to classes, features, or account suspension.</li>
            </ul>
            <p class="text-body mb-3">
                3.4.7 AI systems operate in accordance with the AI Usage, Ethics &amp; Governance Policy and applicable
                data protection laws.
            </p>

            <p class="text-body font-bold mb-2">3.5 Platform communication &amp; email requirements</p>
            <p class="text-body mb-1">3.5.1 ILearn’d Tutors conducts online sessions using third-party video
                communication tools, including but not limited to Google Meet.</p>
            <p class="text-body mb-2">3.5.2 Users are strongly encouraged to register and use a valid Google (Gmail)
                account to ensure seamless access to classes, scheduling, and integrated Platform features.</p>
            <p class="text-body mb-1">3.5.3 While Gmail accounts are recommended for optimal performance and
                compatibility, users may use alternative email providers. However, ILearn’d Tutors does not guarantee
                full functionality, compatibility, or user experience when non-Google accounts are used.</p>
            <p class="text-body mb-2">3.5.4 Users are solely responsible for ensuring that their email account and
                device meet the technical requirements necessary to access and participate in online sessions.</p>
            <p class="text-body mb-1">3.5.5 ILearn’d Tutors shall not be liable for:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-3">
                <li class="mb-1">(a) failure to join sessions due to incompatible email providers;</li>
                <li class="mb-1">(b) technical limitations of third-party platforms; or</li>
                <li>(c) user-side configuration issues.</li>
            </ul>

            <p class="text-body font-bold mb-2">3.6 STUDENT VERIFICATION PROCESS</p>
            <p class="text-body mb-1">3.6.1 Where a student enrolled with the tutor requests a verification call, the
                tutor shall be responsible for organising and conducting the verification call in accordance with the
                verification process established by ILearn’d Tutors.</p>
            <p class="text-body mb-1">3.6.2 ILearn’d Tutors shall provide the tutor with the applicable verification
                template or designated process for arranging the verification call.</p>
            <p class="text-body mb-1">3.6.3 The tutor may use an appropriate video-conferencing or meeting link in
                accordance with the Platform’s approved verification process.</p>
            <p class="text-body mb-1">3.6.4 The verification call details, including the meeting link provided by the
                tutor, shall be submitted through the designated Platform process so that the relevant information can
                be sent to the student’s registered email address.</p>
            <p class="text-body mb-1">3.6.5 The tutor shall request the verification code issued to the student’s
                registered email address as part of the verification process.</p>
            <p class="text-body mb-1">3.6.6 The tutor shall not request, retain, or use the student’s verification code
                for any purpose other than completing the verification process.</p>
            <p class="text-body mb-1">3.6.7 The tutor shall not schedule tutoring classes for the student until the
                required verification process has been successfully completed and the verification code has been
                confirmed.</p>
            <p class="text-body mb-1">3.6.8 Tutors shall conduct verification calls professionally and solely for the
                purpose of confirming the student–tutor relationship and enabling secure access to class scheduling.
            </p>
            <p class="text-body">3.6.9 Any attempt to bypass, falsify, manipulate, or improperly complete the
                verification process may constitute a breach of these Terms and may result in suspension or termination
                of the tutor account.</p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">4. PAYMENT TERMS</h2>

            <p class="text-body font-bold mb-1">4.1 Platform-Only Booking and Payments (Mandatory &amp; Safety Requirement)
            </p>
            <p class="text-body mb-2">
                4.1.1 All tutoring sessions shall be <b>booked, scheduled, conducted, and paid for exclusively through
                    the ILearn’d Tutors Platform</b>. This requirement is implemented for safety, safeguarding
                (particularly where minors are involved), record-keeping, dispute resolution, and regulatory compliance
                purposes.
            </p>
            <p class="text-body mb-2">
                4.1.2 ILearn’d Tutors <b>does not assume any responsibility or liability</b> for any sessions,
                interactions, communications, or payments that are arranged or conducted <b>outside the Platform</b>,
                whether online or offline.
            </p>
            <p class="text-body mb-3">
                4.1.3 Any attempt to arrange, conduct, accept payment for, or facilitate tutoring sessions outside the
                Platform shall constitute a <b>material breach</b> of these Terms and may result in <b>temporary
                    suspension or permanent termination</b> of the tutor account and any associated accounts.
            </p>

            <p class="text-body mb-4">
                4.2 <b>Tutor Rates</b> - Tutors may set their own hourly rates <b>within the pricing guidelines
                    prescribed by the Platform</b> and communicated from time to time. As at the Effective Date of these
                Terms, the indicative permissible rate range is <b>LKR 500 to LKR 5,000 per hour</b>, subject to review
                and revision by ILearn’d Tutors.
            </p>

            <p class="text-body font-bold mb-1">4.3 Session Authorization &amp; Payment Processing</p>
            <p class="text-body mb-2">
                4.3.1 By booking a tutoring session through the Platform, students authorize ILearn’d Tutors to securely
                store and authorize a valid payment method for the applicable session fee.
            </p>
            <p class="text-body mb-1">4.3.2 Tutors acknowledge and agree that:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) payment collection is handled solely by the Platform;</li>
                <li class="mb-1">(b) the applicable session fee shall only be charged upon successful completion of the
                    session; and</li>
                <li>(c) the Platform’s session records, attendance logs, completion confirmations, and participation
                    data shall constitute the authoritative basis for payment processing.</li>
            </ul>

            <p class="text-body mb-1">4.3.3 A session shall be considered successfully completed where:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) both tutor and student have attended the session;</li>
                <li class="mb-1">(b) the session has been conducted for a reasonable duration; and</li>
                <li>(c) the session has been marked as completed by both the tutor and the student through the
                    Platform.</li>
            </ul>

            <p class="text-body mb-3">
                4.3.4 Where one party fails to confirm session completion, ILearn’d Tutors reserves the right to review
                session logs, attendance records, participation data, communication history, and other relevant
                Platform data to determine whether the session qualifies as successfully completed.
            </p>

            <p class="text-body mb-1">4.3.5 Upon successful session completion and confirmation in accordance with this
                Clause:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) the applicable session fee shall be charged to the student’s authorised payment
                    method; and</li>
                <li>(b) payment due to the tutor, net of the applicable Commission, shall be released in accordance
                    with these Terms.</li>
            </ul>

            <p class="text-body mb-2">
                4.3.6 Where a session is cancelled, disputed, incomplete, or flagged for investigation, ILearn’d Tutors
                may withhold, reverse, delay, or decline to process the applicable charge pending review.
            </p>
            <p class="text-body mb-4">
                4.3.7 ILearn’d Tutors reserves the right to make the final determination regarding session completion
                for payment and dispute resolution purposes.
            </p>

            <p class="text-body mb-2">4.4 <b>Service Fee / Commission</b></p>
            <p class="text-body mb-2">
                4.4.1 ILearn’d Tutors shall deduct a <b>service fee (“Commission”)</b> from each tutoring session
                successfully completed through the Platform. The applicable Commission shall be calculated as a
                <b>percentage of the session fee</b>, determined based on the academic grade level of the student at the
                time of booking.
            </p>
            <p class="text-body mb-2">4.4.2 The Commission rates applicable to online bookings as at the Effective Date
                of these Terms are as follows:</p>

            <div class="overflow-x-auto mb-3">
                <table class="w-full border-collapse border border-300 text-body">
                    <thead>
                        <tr class="bg-faded">
                            <th class="border border-300 p-2 text-left font-bold">Grade Level</th>
                            <th class="border border-300 p-2 text-left font-bold">Commission Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="border border-300 p-2">Grade 5</td>
                            <td class="border border-300 p-2">8%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">Grades 6–9</td>
                            <td class="border border-300 p-2">10%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">G.C.E. Ordinary Level (10 and 11)</td>
                            <td class="border border-300 p-2">12%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">London O Level</td>
                            <td class="border border-300 p-2">13%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">G.C.E. Advanced Level (A/L) – Local</td>
                            <td class="border border-300 p-2">14%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">Advanced Level (A/L) – London</td>
                            <td class="border border-300 p-2">15%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">Languages</td>
                            <td class="border border-300 p-2">16%</td>
                        </tr>
                        <tr>
                            <td class="border border-300 p-2">Skill Development</td>
                            <td class="border border-300 p-2">16%</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <p class="text-body mb-2">
                4.4.3 The applicable Commission rate shall be <b>clearly displayed to the tutor at the time of booking
                    or session confirmation</b> and shall be deducted automatically by the Platform prior to payment
                release.
            </p>
            <p class="text-body mb-1">
                4.4.4 ILearn’d Tutors reserves the right to <b>review, revise, or update</b> the Commission structure
                from time to time. Any material change shall be:
            </p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) communicated to tutors in advance through the Platform; and</li>
                <li>(b) applied <b>prospectively only</b>, without affecting sessions already booked or completed.</li>
            </ul>

            <p class="text-body mb-2">4.5 <b>Charges, Cancellations &amp; No-Shows</b></p>
            <p class="text-body mb-1">4.5.1 Student-Initiated Cancellations</p>
            <p class="text-body mb-1">Where a student cancels a scheduled session:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) <b>twenty-four (24) hours or more</b> before the scheduled start time – <b>no
                        session fee shall be charged</b>;</li>
                <li class="mb-1">(b) <b>two (2) to twenty-four (24) hours</b> before the scheduled start time – <b>no
                        session fee shall be charged</b>;</li>
                <li>(c) <b>less than two (2) hours</b> before the scheduled start time, or in the event of a student
                    no-show – ILearn’d Tutors reserves the right to <b>charge the full session fee or a cancellation
                        fee</b>, in accordance with Platform rules.</li>
            </ul>

            <p class="text-body mb-1">4.5.2 Tutor-Initiated Cancellations or No-Shows</p>
            <p class="text-body mb-1">Where a tutor cancels a session at any time, or fails to attend a scheduled
                session without valid justification:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) <b>no session fee shall be charged</b> to the student; and</li>
                <li>(b) the tutor may be subject to warnings, reduced platform visibility, financial penalties,
                    temporary suspension, or permanent termination of the tutor account in the event of repeated
                    cancellations or no-shows.</li>
            </ul>

            <p class="text-body mb-1">4.6 <b>Payment Release to Tutors</b></p>
            <p class="text-body mb-1">Subject to:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) successful session completion;</li>
                <li class="mb-1">(b) confirmation of completion in accordance with Clause 4.3;</li>
                <li class="mb-1">(c) successful charge processing from the student’s authorised payment method; and</li>
                <li>(d) the absence of unresolved disputes or investigations,</li>
            </ul>
            <p class="text-body mb-2">
                payments due to tutors, net of the applicable Commission, shall be released to the tutor’s verified
                bank account within twenty-four (24) to forty-eight (48) hours, or within such other timeframe as may
                be notified by the Platform.
            </p>
            <p class="text-body mb-4">
                ILearn’d Tutors shall not be responsible for delays caused by banks, payment gateways, financial
                institutions, or third-party payment processors.
            </p>

            <p class="text-body mb-1">4.7 <b>Refunds</b></p>
            <p class="text-body mb-1">Refunds, payment reversals, or cancellation of authorised charges may apply only
                where:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">(a) a verified Platform-related technical failure occurred;</li>
                <li class="mb-1">(b) an incorrect or duplicate charge was processed due to a system error;</li>
                <li class="mb-1">(c) the tutor failed to attend the scheduled session; or</li>
                <li>(d) a dispute or investigation is resolved in favour of the student.</li>
            </ul>
            <p class="text-body mb-2">
                Where a session is disputed, ILearn’d Tutors reserves the right to temporarily withhold tutor payouts
                pending investigation and resolution in accordance with the Platform’s Refund Policy and Formal
                Complaints Procedure.
            </p>
            <p class="text-body mb-4">
                All refunds, reversals, disputes, and investigations shall be handled in accordance with the Platform’s
                Refund Policy.
            </p>

            <p class="text-body mb-1">4.8 <b>Prohibited Practices</b></p>
            <p class="text-body mb-1">Tutors shall not:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-2">
                <li class="mb-1">4.8.1 receive, request, or facilitate any direct, cash, or off-platform payments from
                    students or parents;</li>
                <li class="mb-1">4.8.2 accept gifts, benefits, tips, or gratuities exceeding <b>LKR 1,000</b> in value;
                    or</li>
                <li>4.8.3 charge or attempt to charge any additional, hidden, or unofficial fees outside the Platform.
                </li>
            </ul>

            <p class="text-body mt-3">
                Any breach of this Clause shall constitute a <b>material violation</b> of these Terms and may result in
                <b>immediate suspension or permanent termination</b> of the tutor account, without prejudice to any
                other rights or remedies available to ILearn’d Tutors.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">5. EDUCATIONAL AND QUALITY STANDARDS</h2>
            <p class="text-body mb-2">5.1 All tutoring shall comply with Sri Lankan national curriculum standards or
                relevant international syllabi.</p>
            <p class="text-body mb-2">5.2 Tutors must use appropriate educational materials and prepare students
                ethically.</p>
            <p class="text-body mb-2">5.3 Lesson quality is subject to review through student ratings and periodic
                audits.</p>
            <p class="text-body mb-2">5.4 Minimum performance rating of <b>4.0/5.0</b> is required to remain active.</p>
            <p class="text-body">5.5 Tutors are encouraged to participate in ongoing professional development programs.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">6. PAST PAPERS and MARKING SCHEMES SYSTEM AND CONTENT POLICY</h2>

            <p class="text-body font-bold mb-1">6.1 Access to Past Papers Database</p>
            <p class="text-body mb-3">
                Tutors shall have access to the Platform’s Past Papers and Marking schemes Database, which includes
                <b>verified past examination papers and corresponding marking schemes</b>, strictly <b>limited to the
                    subjects and academic grade levels that the tutor is authorised to teach on the Platform</b>.
            </p>

            <p class="text-body font-bold mb-1">6.2 Permitted Use of Past Papers</p>
            <p class="text-body mb-3">
                Tutors may use past examination papers <b>together with the relevant marking schemes</b> solely for
                <b>instructional, practice, revision, and assessment purposes</b> within sessions conducted through the
                Platform. Such use shall be confined exclusively to educational activities conducted on the Platform.
            </p>

            <p class="text-body font-bold mb-1">6.3 Academic Responsibility and Feedback</p>
            <p class="text-body mb-1">Tutors shall be responsible for:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">6.3.1 marking past paper answers <b>accurately and in accordance with the applicable
                        marking scheme</b>;</li>
                <li class="mb-1">6.3.2 providing clear, constructive, and timely feedback to students; and</li>
                <li>6.3.3 assisting students in identifying and improving areas of weakness, gaps in understanding, or
                    recurring errors identified through past paper practice.</li>
            </ul>

            <p class="text-body font-bold mb-1">6.4 Prohibited Uses of Past Papers and Student Content</p>
            <p class="text-body mb-1">Without limitation, tutors shall not:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">6.4.1 share, distribute, upload, or make available past examination papers or marking
                    schemes outside the Platform</li>
                <li class="mb-1">6.4.2 commercially resell, reproduce, publish, or exploit past papers or marking
                    schemes in any form;</li>
                <li class="mb-1">6.4.3 claim authorship or ownership of official examination papers, marking schemes, or
                    related materials; or</li>
                <li>6.4.4 use, reproduce, distribute, or present <b>student answers or student-submitted work</b> as
                    model answers, sample solutions, or teaching materials for future classes <b>without the express
                        prior consent of the relevant student or their parent or legal guardian</b>, where applicable.
                </li>
            </ul>

            <p class="text-body font-bold mb-1">6.5 Contribution of Additional Materials</p>
            <p class="text-body mb-3">
                Tutors are encouraged to contribute additional verified past papers, marking schemes, and model answers
                to the Platform’s database, subject to review, verification, and approval by ILearn’d Tutors.
            </p>

            <p class="text-body font-bold mb-1">6.6 Integration and Performance Reporting</p>
            <p class="text-body">
                Tutors shall integrate past paper practice into regular lessons where appropriate and shall record,
                track, and report student performance and progress through the Platform’s analytics and reporting tools,
                in accordance with Platform guidelines.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">7. CONTRIBUTIONS &amp; INTELLECTUAL PROPERTY</h2>

            <p class="text-body font-bold mb-1">7.1 Definition of Contribution</p>
            <p class="text-body mb-2">
                “<b>Contribution</b>” shall mean any code, documentation, content, materials, data, or other original
                works of authorship, including any modifications or additions to an existing work, that are
                intentionally submitted by you to ILearn’d Tutors for inclusion in, or documentation of, any products,
                services, systems, or materials owned or managed by ILearn’d Tutors (the “<b>Work</b>”).
            </p>
            <p class="text-body mb-3">
                For the purposes of this definition, “<b>submitted</b>” means any form of electronic, verbal, or written
                communication sent to ILearn’d Tutors or its representatives, including but not limited to
                communications through electronic mail, platform interfaces, content submission tools, source control
                systems, or issue-tracking systems managed by or on behalf of ILearn’d Tutors, but excluding
                communications that are expressly marked in writing as <b>“Not a Contribution.”</b>
            </p>

            <p class="text-body font-bold mb-1">7.2 Contributor Representations</p>
            <p class="text-body mb-1">You represent and warrant that each of your Contributions:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">7.2.1 is your original creation, <b>or</b> that you otherwise have the legal right,
                    authority, and permission to submit such Contribution; and</li>
                <li>7.2.2 does not infringe or misappropriate any intellectual property, privacy, or other proprietary
                    rights of any third party.</li>
            </ul>

            <p class="text-body font-bold mb-1">7.3 Grant of Copyright License</p>
            <p class="text-body mb-4">
                Subject to the terms and conditions of this Agreement, you hereby grant to ILearn’d Tutors a
                <b>perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license</b> to
                reproduce, prepare derivative works of, publicly display, publicly perform, sublicense, and distribute
                your Contributions and any derivative works thereof, in any media or format, whether now known or
                hereafter developed.
            </p>

            <p class="text-body font-bold mb-1">7.4 Grant of Patent License</p>
            <p class="text-body mb-2">
                Subject to the terms and conditions of this Agreement, you hereby grant to ILearn’d Tutors a
                <b>perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable patent license</b> (except
                as expressly stated in this Clause) to make, have made, use, offer to sell, sell, import, and otherwise
                transfer the Work, where such license applies only to those patent claims licensable by you that are
                necessarily infringed by your Contribution(s), either alone or in combination with the Work to which
                such Contribution(s) were submitted.
            </p>
            <p class="text-body mb-4">
                If you or any entity institute patent litigation (including a cross-claim or counterclaim) alleging
                that a Contribution or the Work constitutes direct or contributory patent infringement, then any patent
                licenses granted under this Agreement with respect to such Contribution or Work shall automatically
                terminate as of the date such litigation is filed.
            </p>

            <p class="text-body font-bold mb-1">7.5 Sublicensing Rights</p>
            <p class="text-body">
                The licenses granted to ILearn’d Tutors under this Clause include the right to <b>grant and authorise
                    sublicenses</b> to third parties, including affiliates, partners, service providers, and end users,
                in connection with the operation, distribution, or enhancement of the Platform and related products or
                services
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">8. CHILD PROTECTION AND SAFEGUARDING</h2>

            <p class="text-body mb-1">8.1 <b>Zero-Tolerance Policy</b></p>
            <p class="text-body mb-3">
                ILearn’d Tutors enforces a <b>zero-tolerance policy</b> towards any form of child abuse, exploitation,
                grooming, harassment, or inappropriate behaviour involving minors on or in connection with the Platform.
            </p>

            <p class="text-body mb-1">8.2 <b>Legal Compliance and Reporting Obligations</b></p>
            <p class="text-body mb-1">
                Tutors shall comply with all applicable child protection and safeguarding laws and regulations of the
                Democratic Socialist Republic of Sri Lanka. Tutors are required to <b>immediately report</b> any suspicion,
                allegation, or knowledge of child abuse, exploitation, grooming, or endangerment to:
            </p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-3">
                <li class="mb-1">8.2.1 the relevant competent authorities; and</li>
                <li>8.2.2 ILearn’d Tutors through the Platform’s designated reporting or safety mechanisms.</li>
            </ul>

            <p class="text-body mb-1">8.3 <b>Prohibited Conduct by Tutors</b></p>
            <p class="text-body mb-1">Tutors shall not, under any circumstances:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">8.3.1 communicate with students through personal messaging applications, private phone
                    numbers, email accounts, or social media platforms outside the Platform;</li>
                <li class="mb-1">8.3.2 make inappropriate remarks, comments, or engage in discussions that are unrelated
                    to educational instruction or that may reasonably be considered offensive, suggestive, or harmful;
                    or</li>
                <li>8.3.3 conduct closed-door, unsupervised, or private sessions with minors in a manner that
                    compromises transparency, safety, or safeguarding requirements.</li>
            </ul>

            <p class="text-body mb-1">8.4 <b>Enforcement and Consequences</b></p>
            <p class="text-body mb-1">Failure to comply with this Clause shall constitute a <b>material breach</b> of these
                Terms and may result in:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">8.4.1 immediate suspension or permanent termination of the tutor account;</li>
                <li class="mb-1">8.4.2 reporting of the matter to relevant authorities; and</li>
                <li>8.4.3 any other action deemed necessary by ILearn’d Tutors to protect the safety and welfare of
                    minors.</li>
            </ul>

            <p class="text-body mb-1">8.5 <b>Supplementary Policies</b></p>
            <p class="text-body">
                This Clause shall be read together with the Platform’s <b>Child Protection &amp; Safeguarding Policy</b> and
                <b>Parental Consent Policy</b>, which form integral parts of these Terms.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">9. DATA PROTECTION AND PRIVACY</h2>

            <p class="text-body mb-1">9.1 <b>Compliance with Data Protection Laws</b></p>
            <p class="text-body mb-3">
                ILearn’d Tutors processes all personal data in accordance with the <b>Personal Data Protection Act, No. 9
                of 2022 of Sri Lanka (“PDPA”)</b>, the Platform’s Privacy Policy, and all other applicable data protection
                laws and regulations.
            </p>

            <p class="text-body mb-1">9.2 <b>Tutor Confidentiality Obligations</b></p>
            <p class="text-body mb-3">
                Tutors shall treat all personal data, student information, and educational records obtained through the
                Platform as <b>strictly confidential</b> and shall process such data <b>solely for legitimate educational and
                instructional purposes</b> within the scope of sessions conducted through the Platform.
            </p>

            <p class="text-body mb-1">9.3 <b>Platform Data Storage and Monitoring</b></p>
            <p class="text-body mb-3">
                For the purposes of quality assurance, safety monitoring, dispute resolution, and service improvement,
                the Platform may store session-related data, including attendance records and performance analytics, for a period of <b>up to ninety (90) days</b>, unless a longer retention period is required by law or for the
                resolution of an ongoing dispute.
            </p>

            <p class="text-body mb-1">9.4 <b>Restrictions on Data Use and Disclosure</b></p>
            <p class="text-body mb-1">Tutors shall not, under any circumstances:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">9.4.1 disclose, share, sell, transfer, or otherwise make available any personal data
                    obtained through the Platform to any unauthorised third party;</li>
                <li class="mb-1">9.4.2 misuse personal data for any purpose unrelated to educational delivery on the
                    Platform; or</li>
                <li>9.4.3 retain, copy, or store personal data outside the Platform in a manner that violates applicable
                    data protection laws or Platform policies.</li>
            </ul>

            <p class="text-body mb-1">9.5 <b>Enforcement and Consequences</b></p>
            <p class="text-body mb-3">
                Any breach of this Clause shall constitute a <b>material violation</b> of these Terms and may result in
                suspension or permanent termination of the tutor account, reporting to relevant authorities where
                required by law, and any other remedies available to ILearn’d Tutors.
            </p>

            <p class="text-body mb-1">9.6 <b>Supplementary Policies</b></p>
            <p class="text-body">
                This Clause shall be read together with the Platform’s <b>Privacy Policy</b> and <b>Data Protection Guidelines</b>,
                which form an integral part of these Terms.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">10. SAFETY AND SOS EMERGENCY SYSTEM</h2>

            <p class="text-body mb-1">10.1 <b>Purpose and Use of the SOS System</b></p>
            <p class="text-body mb-3">
                The Platform provides a <b>Safety and SOS Emergency System</b> to enable the prompt reporting of emergency
                situations, including but not limited to medical incidents, inappropriate conduct, safeguarding
                concerns, or immediate safety threats arising during sessions conducted through the Platform.
            </p>

            <p class="text-body mb-1">10.2 <b>Incident Logging and Response</b></p>
            <p class="text-body mb-1">Where the SOS feature is activated:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-3">
                <li class="mb-1">10.2.1 the Platform may log and record the incident, including relevant session data
                    and timestamps;</li>
                <li class="mb-1">10.2.2 ILearn’d Tutors may notify or cooperate with <b>relevant authorities, emergency
                    services, or safeguarding bodies</b> where required by law or where reasonably necessary to protect the
                    safety and welfare of users; and</li>
                <li>10.2.3 ILearn’d Tutors may initiate follow-up reviews or investigations in accordance with its
                    internal safety, safeguarding, and dispute resolution procedures.</li>
            </ul>

            <p class="text-body mb-1">10.3 <b>Tutor Responsibilities</b></p>
            <p class="text-body mb-3">
                Tutors shall ensure that their <b>emergency contact details</b> are accurate, complete, and kept up to date
                within their Platform profile at all times. Failure to maintain current emergency contact information
                may result in restricted access to Platform features or other enforcement action.
            </p>

            <p class="text-body mb-1">10.4 <b>Limitations of Emergency Services</b></p>
            <p class="text-body mb-3">
                Tutors acknowledge and agree that ILearn’d Tutors <b>does not provide emergency or medical services</b> and
                does not guarantee response times or outcomes following activation of the SOS feature. Emergency
                response times and actions may vary depending on location, circumstances, and the availability of
                third-party emergency services.
            </p>

            <p class="text-body mb-1">10.5 <b>No Assumption of Liability</b></p>
            <p class="text-body">
                To the maximum extent permitted by applicable law, ILearn’d Tutors shall not be liable for delays,
                failures, or outcomes relating to emergency responses initiated through the SOS system, provided that
                nothing in this Clause shall exclude or limit liability where such exclusion or limitation is not
                permitted by law.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">11. DISPUTE RESOLUTION</h2>

            <p class="text-body mb-1">11.1 <b>Submission of Complaints</b></p>
            <p class="text-body mb-2">
                All complaints or concerns relating to payments, safety, safeguarding, session conduct, or educational
                quality shall be submitted through the Platform’s designated complaints mechanism <b>as soon as reasonably
                practicable and, in any event, within forty-eight (48) hours</b> of the relevant incident or session.
            </p>
            <p class="text-body mb-3">
                Where a complaint cannot be submitted within the above timeframe due to circumstances <b>beyond the
                reasonable control of the tutor</b>, including but not limited to illness, medical emergencies, natural
                disasters, power outages, internet or electrical service disruptions, or other force majeure events,
                ILearn’d Tutors may, at its discretion, accept and review such complaints submitted within a reasonable
                period thereafter.
            </p>

            <p class="text-body mb-1">11.2 <b>Formal Complaints Procedure</b></p>
            <p class="text-body mb-3">
                The submission, handling, escalation, and resolution of complaints shall be governed by the Platform’s
                <b>Formal Complaints Procedure</b>, which forms an integral part of these Terms and sets out the applicable
                processes, timelines, and communication standards.
            </p>

            <p class="text-body mb-1">11.3 <b>Dispute Resolution Process</b></p>
            <p class="text-body mb-1">Subject to the Formal Complaints Procedure, complaints and disputes shall
                generally be handled in the following order, as applicable:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">11.3.1 <b>Automated Review</b> – an initial system-based assessment using session records,
                    logs, and Platform data;</li>
                <li class="mb-1">11.3.2 <b>Customer Support Investigation</b> – review by the Platform’s customer service or
                    support team, including engagement with relevant parties;</li>
                <li class="mb-1">11.3.3 <b>Management Review</b> – escalation to Platform management for further assessment and
                    decision-making where necessary; and</li>
                <li>11.3.4 <b>External Resolution</b> – referral to mediation or other alternative dispute resolution
                    mechanisms, where appropriate or legally required.</li>
            </ul>

            <p class="text-body mb-1">11.4 <b>Decisions and Rights</b></p>
            <p class="text-body mb-3">
                Subject to applicable law, decisions made following completion of the internal dispute resolution
                process shall apply to <b>Platform-related matters</b>, including account access, enforcement actions, and
                payment handling. Nothing in this Clause shall restrict the right of any party to seek relief through a
                court of competent jurisdiction.
            </p>

            <p class="text-body mb-1">11.5 <b>Cooperation Obligation</b></p>
            <p class="text-body">
                Tutors shall cooperate fully and in good faith with any investigation or review conducted under this
                Clause, including by providing accurate information and responding promptly to reasonable requests.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">12. TERMINATION AND SUSPENSION</h2>

            <p class="text-body mb-1">12.1 The Platform reserves the right to suspend or terminate tutor accounts for:
            </p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) Breach of these Terms;</li>
                <li class="mb-1">(b) Misconduct or unprofessional behavior;</li>
                <li class="mb-1">(c) Fraudulent qualifications or misrepresentation;</li>
                <li>(d) Poor performance or repeated complaints.</li>
            </ul>

            <p class="text-body mb-3">
                12.2 Tutors may terminate their account voluntarily with <b>30 days’ written notice</b>, subject to completion
                of scheduled sessions and financial settlements.
            </p>

            <p class="text-body">
                12.3 ILearn’d Tutors retains the right to retain or delete tutor data as required for compliance with
                legal or regulatory obligations.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">13. LIMITATION OF LIABILITY</h2>

            <p class="text-body mb-1">13.1 ILearn’d Tutors shall not be liable for:</p>
            <ul class="text-body list-none p-0 m-0 ml-3 mb-4">
                <li class="mb-1">(a) Any indirect or consequential damages;</li>
                <li class="mb-1">(b) Loss of earnings or reputation;</li>
                <li class="mb-1">(c) Technical interruptions beyond its control;</li>
                <li>(d) Student conduct or off-platform interactions.</li>
            </ul>

            <p class="text-body">
                13.2 The Platform’s total liability shall not exceed the total service fees paid to it by the tutor
                during the six (6) months preceding the event giving rise to the claim.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">14. GOVERNING LAW AND JURISDICTION</h2>
            <p class="text-body mb-2">Governing Law and Jurisdiction</p>
            <p class="text-body mb-2">
                These Terms shall be governed by and construed in accordance with the laws of the Democratic Socialist
                Republic of Sri Lanka.
            </p>
            <p class="text-body">
                Any dispute arising out of or in connection with these Terms shall be subject to the jurisdiction of the
                courts of Sri Lanka.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">15. AMENDMENTS</h2>
            <p class="text-body">
                ILearn’d Tutors reserves the right to amend these Terms at any time. Updates will be posted on the
                Platform, and continued use constitutes acceptance of such revisions.
            </p>
        </div>

        <div class="policy-section mb-5">
            <h2 class="H5-SemiBold text-primary mb-3">16. CONTACT AND SUPPORT</h2>
            <p class="text-body font-bold mb-2">ILearn’d Tutors – Legal Team</p>
            <p class="text-body mb-1">
                Email: <a href="mailto:support@ilearndsl.com"
                    class="text-primary no-underline">support@ilearndsl.com</a>
            </p>
            <p class="text-body">
                Address: 306/1 Highlevel Road, Colombo 06, Sri Lanka
            </p>
        </div>

        <div class="policy-section">
            <h2 class="H5-SemiBold text-primary mb-3">VERSION CONTROL</h2>
            <div class="overflow-x-auto">
                <table class="w-full border-collapse border border-300 text-body version-table">
                    <thead>
                        <tr class="bg-faded">
                            <th class="border border-300 p-2 text-left font-bold">VERSION</th>
                            <th class="border border-300 p-2 text-left font-bold">DATE</th>
                            <th class="border border-300 p-2 text-left font-bold">DESCRIPTION</th>
                            <th class="border border-300 p-2 text-left font-bold">APPROVED BY</th>
                            <th class="border border-300 p-2 text-center font-bold">SIGNATURE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="border border-300 p-2">1.0</td>
                            <td class="border border-300 p-2">11/03/2026</td>
                            <td class="border border-300 p-2">Initial Release</td>
                            <td class="border border-300 p-2">Founder</td>
                            <td class="border border-300 p-0 text-center">
                                <img :src="founderSignature" alt="Founder signature"
                                    class="signature-img" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
import founderSignature from "@/assets/founder-signature.png";
</script>

<style scoped>
.text-primary {
    color: #1D97BD !important;
}

.bg-faded {
    background-color: rgba(29, 151, 189, 0.04);
}

.text-body {
    font-size: 0.95rem;
    color: #4A5568;
    font-weight: 400;
    line-height: 1.6;
}

/* VERSION CONTROL table */
.version-table th,
.version-table td {
    vertical-align: middle;
    white-space: nowrap;
}

.version-table td:nth-child(3) {
    white-space: normal;
}

.signature-img {
    height: 120px;
    width: auto;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
}
</style>
